import { render } from "./HomeButton.vue?vue&type=template&id=80841032"
import script from "./HomeButton.vue?vue&type=script&lang=js"
export * from "./HomeButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__